import React from 'react';

import { useHistory } from 'react-router-dom';

import { Container } from './styles';

import { IProviders } from '../../../interfaces/Providers';
import { ArrowLeft, MonitorPlay } from 'phosphor-react';

interface IAulaLiteProps {
  video: string;
  provider: IProviders;
}

const AulaLite: React.FC<IAulaLiteProps> = () => {
  const router = useHistory();

  const quryParams = new URLSearchParams(window.location.search);
  const video = quryParams.get('video');
  const provider = quryParams.get('provider');
  const title = quryParams.get('title');

  if (!video || !provider || !title) {
    router.push('/');
  }

  return (
    <Container>
      <main>
        <header>
          <p>
            <strong>
              <MonitorPlay size={18} color="#ffffff" weight="duotone" /> Lite
              mode
            </strong>
          </p>
          <button onClick={() => window.history.back()}>
            <ArrowLeft weight="duotone" />
            Voltar para a plataforma
          </button>
        </header>

        <h1>{title}</h1>
        <footer>
          {provider === 'panda' && video && (
            <iframe
              id={`panda-${video}`}
              src={`https://player-vz-27884646-502.tv.pandavideo.com.br/embed/?v=${video}`}
              title="Plataforma"
              allowFullScreen
            />
          )}
          {/*
           // Arrumar link do Vimeo
          {provider === 'vimeo' && video && (
            <iframe src={video} title="Plataforma" allowFullScreen />
          )} */}
        </footer>
      </main>
    </Container>
  );
};

export default AulaLite;
